module.exports = __webpack_public_path__ + "static/media/clock.6bd293ef.svg";